import { render } from "./UpdateCard.vue?vue&type=template&id=fbb91794&scoped=true"
import script from "./UpdateCard.vue?vue&type=script&lang=js"
export * from "./UpdateCard.vue?vue&type=script&lang=js"

import "./UpdateCard.vue?vue&type=style&index=0&id=fbb91794&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbb91794"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QChip});
